module.exports = __webpack_public_path__ + "img/urCoursesBlack.e07ba552.svg";